<div class="p-4 flex flex-col gap-3" *transloco="let t; read 'prices';">
  <div class="flex gap-4">
    <psc-button
      size="small"
      type="secondary-blue"
      [routerLink]="['add']"
      [queryParams]="{'type': 'regular'}">
      <div class="flex gap-2 items-center justify-center">
        {{ (UserRole.ROLE_ADMIN | userHasRole) ? t('add_new.public') : t('add_new.private') }}
        <mat-icon>add</mat-icon>
      </div>
    </psc-button>
    <psc-button
      size="small"
      type="secondary-blue"
      [routerLink]="['add']"
      [queryParams]="{'type': 'block'}">
      <div class="flex gap-2 items-center justify-center">
        {{ t('add_new.block') }}
        <mat-icon>add</mat-icon>
      </div>
    </psc-button>
  </div>

  <!--  t(prices.name,prices.tariff_model,prices.country,prices.currency,prices.privacy_status,prices.tax,prices.price_type)  -->
  <ngx-datatable
    [messages]="{emptyMessage: 'no_data_in_table' | transloco}"
    class="material"
    columnMode="flex"
    [loadingIndicator]="loading"
    [rows]="prices"
    [rowHeight]="50"
    [headerHeight]="50">
    <ngx-datatable-column
      *ngFor="let column of columns"
      [flexGrow]="column.flexGrow"
      [name]="t(column.translationKey)"
      [prop]="column.prop">
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="2"
      [name]="t('sunday')"
      prop="sunday">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value ? t('true') : t('false') }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('tax')"
      prop="tax">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value }}%
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="2"
      [name]="t('lastModify')"
      prop="lastModify">
      <ng-template let-value="value" ngx-datatable-cell-template>
        {{ value | date:'dd.MM.yyyy.' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
      [flexGrow]="1"
      [name]="t('actions')"
      prop="priceId">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div class="flex items-center gap-3">
          <mat-icon
            [matTooltip]="t('edit.title')"
            matTooltipPosition="above"
            [routerLink]="['edit/' + value]"
            class="text-color-blue1 cursor-pointer hover:opacity-60">edit
          </mat-icon>
          <mat-icon
            [matTooltip]="t('delete')"
            matTooltipPosition="above"
            (click)="deleteParameterClicked(value)"
            class="text-color-magenta cursor-pointer hover:opacity-60">delete
          </mat-icon>
        </div>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
